import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-63807476"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["onClick"]
const _hoisted_2 = { style: {"margin-left":"10px"} }
const _hoisted_3 = { style: {"margin-left":"8px"} }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "operation-btn" }, "Upload", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "operation-btn" }, "Delete", -1))
const _hoisted_6 = { class: "remark" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Remark: ")
const _hoisted_8 = { style: {"margin-left":"2px","margin-right":"2px"} }
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" marks the final version of sales measure summary ")
const _hoisted_10 = { class: "footer" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode("Cancel")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CheckCircleTwoTone = _resolveComponent("CheckCircleTwoTone")!
  const _component_a_upload = _resolveComponent("a-upload")!
  const _component_a_popconfirm = _resolveComponent("a-popconfirm")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_drawer = _resolveComponent("a-drawer")!

  return (_openBlock(), _createBlock(_component_a_drawer, {
    title: "Sales Measure Summary",
    placement: "right",
    visible: _ctx.visible,
    width: "800",
    onClose: _ctx.cancel
  }, {
    default: _withCtx(() => [
      _createVNode(_component_a_table, {
        dataSource: _ctx.dataSource,
        columns: _ctx.columns,
        pagination: false
      }, {
        FileName: _withCtx(({ record }) => [
          _createElementVNode("a", {
            onClick: ($event: any) => (_ctx.download(record.originalSmlName))
          }, _toDisplayString(record.originalSmlName), 9, _hoisted_1),
          _createElementVNode("span", _hoisted_2, [
            _withDirectives(_createVNode(_component_CheckCircleTwoTone, { twoToneColor: "#52c41a" }, null, 512), [
              [_vShow, !_ctx.isUploadByUser]
            ])
          ])
        ]),
        UploadedFileName: _withCtx(({ record }) => [
          _createElementVNode("a", null, _toDisplayString(record.replacedSmlName), 1),
          _createElementVNode("span", _hoisted_3, [
            _withDirectives(_createVNode(_component_CheckCircleTwoTone, { twoToneColor: "#52c41a" }, null, 512), [
              [_vShow, _ctx.isUploadByUser]
            ])
          ])
        ]),
        Operation: _withCtx(() => [
          _createVNode(_component_a_upload, {
            name: "file",
            multiple: false,
            showUploadList: false,
            customRequest: (source) => _ctx.uploadRequest(source)
          }, {
            default: _withCtx(() => [
              _hoisted_4
            ]),
            _: 1
          }, 8, ["customRequest"]),
          _createVNode(_component_a_popconfirm, {
            title: "Are you sure you want to delete the file?",
            "ok-text": "Yes",
            "cancel-text": "No",
            onConfirm: _ctx.deleteCurrentRow
          }, {
            default: _withCtx(() => [
              _hoisted_5
            ]),
            _: 1
          }, 8, ["onConfirm"])
        ]),
        _: 1
      }, 8, ["dataSource", "columns"]),
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createElementVNode("span", _hoisted_8, [
          _createVNode(_component_CheckCircleTwoTone, { twoToneColor: "#52c41a" })
        ]),
        _hoisted_9
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createVNode(_component_a_button, { onClick: _ctx.cancel }, {
          default: _withCtx(() => [
            _hoisted_11
          ]),
          _: 1
        }, 8, ["onClick"])
      ])
    ]),
    _: 1
  }, 8, ["visible", "onClose"]))
}